import React from 'react';
import { cn } from '../../lib/utils';
interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'destructive' | 'success' | 'warning' | 'info';
}
export function Badge({
  className,
  variant = 'default',
  ...props
}: BadgeProps) {
  const variants = {
    default: 'border-transparent bg-brand-500 text-white hover:bg-brand-600',
    secondary: 'border-transparent bg-slate-100 text-black hover:bg-slate-100/80',
    outline: 'text-black border-slate-200',
    destructive: 'border-transparent bg-rose-100 text-rose-700 hover:bg-rose-200',
    success: 'border-transparent bg-emerald-100 text-emerald-700 hover:bg-emerald-200',
    warning: 'border-transparent bg-accent-50 text-accent-600 hover:bg-accent-100',
    info: 'border-transparent bg-brand-100 text-brand-600 hover:bg-brand-200'
  };
  return <div className={cn('inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-accent-400 focus:ring-offset-2', variants[variant], className)} {...props} data-id="element-88" />;
}